import { ColumnsType } from "antd/es/table";
import { dateFormatter } from "project-config/utils/date-formatter";
import { useTranslation } from "react-i18next";
import { timeFormatter } from "@/utils/timeFormatter";
import { useGlobalStore } from "@/store/GlobalStore";
import { getDomain } from "project-config/utils/domain";

export function useColumns() {
  const { t } = useTranslation("center");

  const { userInfo } = useGlobalStore();

  const columns: ColumnsType<any> = [
    {
      dataIndex: "feeTypeText",
      title: t("user_consume_table_sort_fee_type"),
      render: (row) => t(row),
    },
    {
      dataIndex: "taskAlias",
      title: t("user_consume_table_sort_id"),
    },
    {
      dataIndex: "sceneName",
      title: t("user_consume_table_sort_scene_name"),
    },
    {
      dataIndex: "taskStatus",
      title: t("user_consume_table_sort_task_status"),
      render: (row) => t(`render_task_status_${row}`),
    },
    {
      dataIndex: "framesRange",
      title: t("user_consume_table_sort_frame"),
    },
    {
      dataIndex: "platformName",
      title: t("user_consume_table_platform"),
    },
    {
      dataIndex: "submitDate",
      title: t("user_consume_table_sort_submit_date"),
      render: (row) => dateFormatter(row),
    },
    {
      dataIndex: "completedDate",
      title: t("user_consume_table_sort_complete_date"),
      render: (row) => dateFormatter(row),
    },
    {
      dataIndex: "producer",
      title: t("user_consume_table_sort_producer"),
    },
    {
      dataIndex: "userName",
      title: t("user_consume_table_sort_user_name"),
    },
    {
      dataIndex: "projectName",
      title: t("user_consume_table_sort_project_name"),
    },
    {
      dataIndex: "cgName",
      title: t("user_consume_table_sort_cg_name"),
    },
    {
      dataIndex: "taskFrameTotal",
      title: t("user_consume_table_sort_frame_total"),
    },
    {
      dataIndex: "renderDuration",
      title: t("user_consume_table_sort_render_duration"),
      render: (row) => timeFormatter(row),
    },
    {
      dataIndex: "userAccountConsume",
      title: t("user_consume_table_sort_balance_consume"),
      render: (userAccountConsume) =>
        userAccountConsume === 0 || userAccountConsume == null
          ? ""
          : t("money_character", {
              c: userInfo?.zone === 1 ? "￥" : "$",
              p: userAccountConsume,
            }),
    },
    {
      dataIndex: "couponConsume",
      title: t("user_consume_table_sort_coupon_consume"),
      render: (couponConsume) =>
        couponConsume === 0 || couponConsume === null
          ? ""
          : t("coupon_character", { 0: couponConsume }),
    },
    !getDomain()
      ? {
          dataIndex: "qycouponConsume",
          title: t("user_consume_table_sort_youth_coupon_consume"),
          render: (qycouponConsume) =>
            qycouponConsume === 0 || qycouponConsume === null
              ? ""
              : qycouponConsume,
        }
      : {},
    {
      dataIndex: "model",
      title: t("user_consume_table_sort_gpu_cpu_model"),
    },
    {
      dataIndex: "graphicsCardsNum",
      title: t("user_consume_table_sort_gpu_cards_num"),
    },
    {
      dataIndex: "taskRam",
      title: t("user_consume_table_sort_task_ram"),
    },
    {
      dataIndex: "labels",
      title: t("render_table_sort_labels"),
      render: (labels) => labelFilters(labels),
    },
  ];

  return { columns };
}

function labelFilters(value: string) {
  if (!value || value === "{}") {
    return "";
  }
  let obj = JSON.parse(value);
  return Object.values(obj).toString();
}
